import axios from 'axios'
import _ from 'lodash'
const state = {
  pending: false,
  dataAuth: {
    login: '',
    password: '',
  },
}

const mutations = {}

const getters = {
  dataAuth(state) {
    return state.dataAuth
  },
}

const actions = {
  login({ commit, dispatch, state }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/auth/login',
        data: state.dataAuth,
      })
        .then((response) => {
          console.log('Login response status:', response.data.status)
          console.log(
            'Login response access_token:',
            response.data.access_token,
          )
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  async attempt({ commit }, token) {
    console.log('Attempt called with token:', token)
    if (token) {
      commit('SET_TOKEN', token)
    }
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
